import { createFileRoute } from "@tanstack/react-router";
import { useContext, useEffect, useMemo, useState } from "react";
import { OmroepContextProvider } from "../component/contextProviders/OmroepContextProvider";
import { FitToScreen } from "../component/slideUtilities/fitToScreen";
import { NextPrevButtonsBar } from "../component/utilities/NextPrevButtonsBar";
import { NextPrevContext } from "../context/nextContext";
import { useGetAllOmroepen } from "../functions/apiFunctions/getAllOmroepen";
import { renderSlide } from "../functions/renderSlide";
import { useProcessWordpressPostData } from "../hooks/useProcessWordpressPostData";
import { useProcessWordpressSlides } from "../hooks/useProcessWordpressSlides";
import { useWordpressPostData } from "../hooks/useWordpressPostData";
import { SlideTypes, WPSlide } from "../types/Slides";
import { RequiredWordpressPost } from "../types/wordpressTypes/wordpressPost";

export enum MessageType {
  NEW_DATA = "new_preview_data"
}

export interface NewData {
  type: MessageType.NEW_DATA;
  data: {
    categoryId: number;
    post: RequiredWordpressPost;
  };
}

export type MessageData = NewData;

export function Preview() {
  const [data, setData] = useState<NewData["data"]>();
  const postObject = useMemo(() => (data?.post != null ? [data.post] : []), [data]);
  const PrevNextContext = useContext(NextPrevContext);
  const [selectedOmroep, setSelectedOmroep] = useState<string | null>(null);

  const { wordpressKabelkrantCategories } = useWordpressPostData();
  const { posts } = useProcessWordpressPostData(postObject, wordpressKabelkrantCategories);
  const { data: omroepen } = useGetAllOmroepen();

  function setOmroep(omroep: string) {
    localStorage.setItem("previewOmroep", omroep);
    setSelectedOmroep(omroep);
  }

  useEffect(() => {
    setSelectedOmroep(localStorage.getItem("previewOmroep"));
    localStorage.getItem("previewOmroep");
  }, []);

  const sideProgram: WPSlide[] = useMemo<WPSlide[]>(
    () => [
      {
        id: 0,
        menu_order: 1,
        acf: {
          menuOrder: 1,
          hasTimespan: false,
          type: SlideTypes.POSTBLOCK,
          postblock: {
            category: typeof data?.post.acf.tv_settings.category == "string" || typeof data?.post.acf.tv_settings.category == "boolean" ? [] : (data?.post.acf.tv_settings.category ?? []),
            mixSlides: false,
            standardImageLength: 5,
            standardLength: 30
          },
          fromDate: null,
          toDate: null
        }
      }
    ],
    [data]
  );
  const { slides } = useProcessWordpressSlides(posts, sideProgram);

  function procesMessage(e: MessageEvent) {
    const message = e.data as MessageData;
    console.log("incomming data iframe", message);
    if (message.type === MessageType.NEW_DATA) {
      setData(message.data);
    }
  }

  function readyForMessage() {
    console.log("ready for message");
    window.parent.postMessage({ type: "send_message" }, "*");
  }

  useEffect(() => {
    PrevNextContext.setAutoGoNext(false);
    readyForMessage();
    window.addEventListener("message", procesMessage);
    return () => {
      window.removeEventListener("message", procesMessage);
    };
  }, []);

  const categoryIsUndefined =
    typeof data?.post.acf.tv_settings.category == "string" ||
    data?.post.acf.tv_settings.category == null ||
    data?.post.acf.tv_settings.category == false ||
    data?.post.acf.tv_settings.category?.length == 0;

  if (data == null || slides[0] == null || categoryIsUndefined) {
    return (
      <div className="flex h-screen flex-col items-center justify-center text-white">
        {categoryIsUndefined ? (
          <div style={{ color: "white" }}>Selecteer eerst een categorie voordat er een preview kan worden weergegeven</div>
        ) : (
          <div style={{ color: "white" }}>Data aan het inladen... </div>
        )}
      </div>
    );
  }

  return (
    <OmroepContextProvider omroep={selectedOmroep ?? omroepen?.data[0].slug ?? ""}>
      <FitToScreen baseHeight={1080} baseWidth={1920}>
        {renderSlide(slides[0])}
      </FitToScreen>
      <NextPrevButtonsBar
        middleComponent={
          <select className="h-fit rounded-sm" value={selectedOmroep ?? ""} onChange={(e) => setOmroep(e.target.value)}>
            {omroepen?.data.map((omroep) => {
              return (
                <option key={omroep.slug} value={omroep.slug}>
                  {omroep.title.rendered}
                </option>
              );
            })}
          </select>
        }
      />
    </OmroepContextProvider>
  );
}

export const Route = createFileRoute("/Preview")({
  component: Preview
});
